import { defineComponent } from "vue";

export default defineComponent({
    template: `
        <div class="InputWidget">
            <div class="InputWidget__inner">
                <div v-if="label" class="InputWidget__label" v-html="label"></div>

                <div class="InputWidget__widget">
                    <slot></slot>
                </div>
            </div>
        </div>
    `,

    props: {
        label: { type: String },
    },
});
